import { isObject } from 'lodash';

export const objectToArray = (values: object | any[]): any[] => {
  if (isObject(values)) {
    return Object.values(values);
  }
  return values;
};
